import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';
@Component({
  selector: 'app-migrate-file',
  templateUrl: './migrate-file.component.html',
  styleUrls: ['./migrate-file.component.css']
})
export class MigrateFileComponent implements OnInit {
  api_error: any;
  api_success: string;
  btndisabled = false;
  id_list: any = [
    {
      "displayName": "Auto",
      "value": "AUTO"
    },
    {
      "displayName": "Manual",
      "value": "MANUAL"
    }]
  public patientForm: UntypedFormGroup;
  showInput = true;
  uid: any;
  accountId: any;
  selectedIdFormat: any;
  migrationTo: any;
  catelogDetails: any;
  inventorycatelogDetails: any;
  remarks: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private accountService: AccountService,
    private formbuilder: UntypedFormBuilder,
    private matDialog: MatDialogRef<any>,) {
      this.uid = this.data.uid;
      this.accountId = this.data.accountId;
      this.migrationTo = this.data.migrationTo;
      this.getCatelog()
      this.getinventorycatalog()
      this.getremarks()
     }
  ngOnInit(): void {
   
    this.createForm();
    console.log(this.data)
  
  }
  createForm() {
  
    if(this.migrationTo === 'CatalogItems'){
     
      this.patientForm = this.formbuilder.group({
        catelog: [],
        otp: []
      });
    }
    else if(this.migrationTo === 'StockAdjust'){
     
      this.patientForm = this.formbuilder.group({
        remark: [],
        otp: []
      });
    }
    else if(this.migrationTo === 'InventoryItems'){
     
      this.patientForm = this.formbuilder.group({
        invcatelog: [],
        otp: []
      });
    }
    else{
      
      this.patientForm = this.formbuilder.group({
        customerIdFormat: ['AUTO'],
        otp: []
      });
    }
  }
  generateOtp() {
    this.btndisabled = false;
    this.api_error = '';
      const selectedTimeZone: string = 'Asia/Kolkata';
      const payloadString = JSON.stringify(selectedTimeZone);
      console.log(selectedTimeZone)
    this.accountService.generateOtp(this.accountId, this.patientForm.get('customerIdFormat').value, this.uid, payloadString)
      .subscribe(res => {
        this.selectedIdFormat = this.patientForm.get('customerIdFormat').value;
        this.api_success = 'OTP Generated successfully';
          setTimeout(() => {
            this.showInput = false;
            this.api_success = ''
          }, 2000);
      },
        (error) => {
          this.api_error = error.error;
          this.btndisabled = false;
        });
  }
  dataMigrate() {
    this.btndisabled = false;
    this.api_error = '';
      const selectedTimeZone: string = 'Asia/Kolkata';
      const payloadString = JSON.stringify(selectedTimeZone);
    this.accountService.dataMigrate(this.accountId, this.selectedIdFormat, this.uid, this.patientForm.get('otp').value, payloadString)
      .subscribe(res => {
        this.api_success = 'Data Migration successfully';
        this.showInput = false;
        setTimeout(() => {
          this.matDialog.close();
        }, 2000);
      },
        (error) => {
          this.api_error = error.error;
          this.btndisabled = false;
        });
  }
  generateOtpForcatelog() {
    if (this.patientForm.get('catelog').value === null) {
      this.api_error = 'Please select catelog';
      setTimeout(() => {
        this.api_error = '';
      }, 2000);
    } else {
      this.api_error = '';
      this.accountService.generateOtpForcatelog(this.accountId, this.patientForm.get('catelog').value, this.uid)
        .subscribe(res => {
          this.selectedIdFormat = this.patientForm.get('catelog').value;
          this.api_success = 'OTP Generated successfully';
            setTimeout(() => {
              this.showInput = false;
              this.api_success = ''
            }, 2000);
        },
          (error) => {
            this.api_error = error.error;
          });
    }
   
  }
  dataMigrateForcatelog() {
    this.btndisabled = false;
    this.api_error = '';
    this.accountService.dataMigrateForcatelog(this.accountId, this.selectedIdFormat, this.uid, this.patientForm.get('otp').value)
      .subscribe(res => {
        this.api_success = 'Data Migration successfully';
        this.showInput = false;
        setTimeout(() => {
          this.matDialog.close();
        }, 2000);
      },
        (error) => {
          this.api_error = error.error;
          this.btndisabled = false;
        });
  }
  generateOtpForinvcatelog() {
    if (this.patientForm.get('invcatelog').value === null) {
      this.api_error = 'Please select catelog';
      setTimeout(() => {
        this.api_error = '';
      }, 2000);
    } else {
      this.api_error = '';
      this.accountService.generateOtpForinvcatelog(this.accountId, this.patientForm.get('invcatelog').value, this.uid)
        .subscribe(res => {
          this.selectedIdFormat = this.patientForm.get('invcatelog').value;
          this.api_success = 'OTP Generated successfully';
            setTimeout(() => {
              this.showInput = false;
              this.api_success = ''
            }, 2000);
        },
          (error) => {
            this.api_error = error.error;
          });
    }
   
  }
  dataMigrateForinvcatelog() {
    this.btndisabled = false;
    this.api_error = '';
    this.accountService.dataMigrateForinvcatelog(this.accountId, this.selectedIdFormat, this.uid, this.patientForm.get('otp').value)
      .subscribe(res => {
        this.api_success = 'Data Migration successfully';
        this.showInput = false;
        setTimeout(() => {
          this.matDialog.close();
        }, 2000);
      },
        (error) => {
          this.api_error = error.error;
          this.btndisabled = false;
        });
  }
  generateOtpForstockAdjust() {
    console.log(this.patientForm.get('remark').value)
    if (this.patientForm.get('remark').value === null) {
      this.api_error = 'Please select remark';
      setTimeout(() => {
        this.api_error = '';
      }, 2000);
    } else {
      this.api_error = '';
      this.accountService.generateOtpForstockAdjust(this.accountId, this.patientForm.get('remark').value, this.uid)
        .subscribe(res => {
          this.selectedIdFormat = this.patientForm.get('remark').value;
          this.api_success = 'OTP Generated successfully';
            setTimeout(() => {
              this.showInput = false;
              this.api_success = ''
            }, 2000);
        },
          (error) => {
            this.api_error = error.error;
          });
    }
   
  }
  dataMigrateForstockAdjust() {
    this.btndisabled = false;
    this.api_error = '';
    this.accountService.dataMigrateForstockAdjust(this.accountId, this.selectedIdFormat, this.uid, this.patientForm.get('otp').value)
      .subscribe(res => {
        this.api_success = 'Data Migration successfully';
        this.showInput = false;
        setTimeout(() => {
          this.matDialog.close();
        }, 2000);
      },
        (error) => {
          this.api_error = error.error;
          this.btndisabled = false;
        });
  }
  generateOtp_notesOrAppt(){
    this.btndisabled = false;
    this.api_error = '';
    console.log(this.migrationTo)
    if(this.migrationTo === 'Appointments'){
      const selectedTimeZone: string = 'Asia/Kolkata';
      const payloadString = JSON.stringify(selectedTimeZone);
      console.log(selectedTimeZone)
      this.accountService.generateOtp_Appt(this.accountId,this.migrationTo,this.uid,payloadString)
      .subscribe(res => {
        this.api_success = 'OTP Generated successfully';
          setTimeout(() => {
            this.showInput = false;
            this.api_success = ''
          }, 2000);
      },
        (error) => {
          this.api_error = error.error;
          this.btndisabled = false;
        });
    }
    else if(this.migrationTo === 'CRMLeads'){
      const selectedTimeZone: string = 'Asia/Kolkata';
      const payloadString = JSON.stringify(selectedTimeZone);
      console.log(selectedTimeZone)
      this.accountService.generateOtpForLeads(this.accountId,this.uid)
      .subscribe(res => {
        this.api_success = 'OTP Generated successfully';
          setTimeout(() => {
            this.showInput = false;
            this.api_success = ''
          }, 2000);
      },
        (error) => {
          this.api_error = error.error;
          this.btndisabled = false;
        });
    }
    else{
      this.accountService.generateOtp_noteSorAppt(this.accountId,this.migrationTo,this.uid)
      .subscribe(res => {
        this.api_success = 'OTP Generated successfully';
          setTimeout(() => {
            this.showInput = false;
            this.api_success = ''
          }, 2000);
      },
        (error) => {
          this.api_error = error.error;
          this.btndisabled = false;
        });
    }
   
  }
  dataMigrate_noteSorAppt() {
    this.btndisabled = false;
    this.api_error = '';
    if(this.migrationTo === 'Appointments'){
      const selectedTimeZone: string = 'Asia/Kolkata';
      const payloadString = JSON.stringify(selectedTimeZone);
    this.accountService.dataMigrate_Appt(this.accountId, this.migrationTo, this.uid, this.patientForm.get('otp').value,payloadString)
      .subscribe(res => {
        this.api_success = 'Data Migration successfully';
        this.showInput = false;
        setTimeout(() => {
          this.matDialog.close();
        }, 2000);
      },
        (error) => {
          this.api_error = error.error;
          this.btndisabled = false;
        });
      }
      else if(this.migrationTo === 'CRMLeads'){
        const selectedTimeZone: string = 'Asia/Kolkata';
      this.accountService.dataMigrateForLeads(this.accountId, this.uid, this.patientForm.get('otp').value)
        .subscribe(res => {
          this.api_success = 'Data Migration successfully';
          this.showInput = false;
          setTimeout(() => {
            this.matDialog.close();
          }, 2000);
        },
          (error) => {
            this.api_error = error.error;
            this.btndisabled = false;
          });
        }
      else{
        this.accountService.dataMigrate_noteSorAppt(this.accountId, this.migrationTo, this.uid, this.patientForm.get('otp').value)
        .subscribe(res => {
          this.api_success = 'Data Migration successfully';
          this.showInput = false;
          setTimeout(() => {
            this.matDialog.close();
          }, 2000);
        },
          (error) => {
            this.api_error = error.error;
            this.btndisabled = false;
          });
      }
  }
  getCatelog(){
    this.accountService.getCatelog(this.accountId)
    .subscribe(
      res => {
        this.catelogDetails = res;
      }
    );
  }
  getinventorycatalog(){
    this.accountService.getinventorycatalog(this.accountId)
    .subscribe(
      res => {
        this.inventorycatelogDetails = res;
      }
    );
  }
  getremarks(){
    this.accountService.getremarks(this.accountId)
    .subscribe(
      res => {
        this.remarks = res;
      }
    );
  }
  
}
